import React from 'react';
import { ShoppingCart, Globe, Megaphone, ArrowUpRight } from 'lucide-react';
import { whatWeDoContent } from '../data/mock';

const iconMap = {
  1: ShoppingCart,
  2: Globe,
  3: Megaphone
};

const WhatWeDoSection = () => {
  return (
    <section id="what-we-do" className="relative bg-[#121212] py-32 overflow-hidden">
      {/* Grid Background */}
      <div 
        className="absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage: `
            repeating-linear-gradient(0deg, transparent, transparent 1px, transparent 1px, transparent 80px),
            repeating-linear-gradient(-90deg, rgba(255,255,255,0.15), rgba(255,255,255,0.15) 1px, transparent 1px, transparent 80px)
          `,
          backgroundSize: '80px 80px'
        }}
      />

      <div className="relative z-10 max-w-[1400px] mx-auto px-5 md:px-[7.6923%]">
        {/* Header */}
        <div className="max-w-3xl mb-20">
          <span className="text-[#00FFD1] text-lg font-medium tracking-wide">Capabilities</span>
          <h2 className="text-4xl md:text-5xl font-semibold text-white leading-tight mt-4">
            {whatWeDoContent.title}
          </h2>
          <p className="text-2xl text-white/60 mt-4">
            {whatWeDoContent.subtitle}
          </p>
          <p className="text-lg text-white/70 leading-relaxed mt-6">
            {whatWeDoContent.description}
          </p>
        </div>

        {/* Use Cases Grid */}
        <div className="grid md:grid-cols-3 gap-6">
          {whatWeDoContent.useCases.map((useCase) => {
            const IconComponent = iconMap[useCase.id];
            return (
              <div
                key={useCase.id}
                className="group relative bg-black border border-white/10 p-8 hover:border-[#00FFD1]/30 transition-all duration-400"
              >
                {/* Hover Glow */}
                <div className="absolute inset-0 bg-[#00FFD1]/5 opacity-0 group-hover:opacity-100 transition-opacity duration-400" />
                
                <div className="relative z-10">
                  {/* Icon */}
                  <div className="w-14 h-14 bg-white/5 flex items-center justify-center mb-6 group-hover:bg-[#00FFD1]/10 transition-colors duration-400">
                    <IconComponent className="w-7 h-7 text-[#00FFD1]" />
                  </div>

                  {/* Content */}
                  <h3 className="text-2xl font-semibold text-white mb-4">
                    {useCase.title}
                  </h3>
                  <p className="text-white/60 leading-relaxed">
                    {useCase.description}
                  </p>

                  {/* Arrow Link */}
                  <div className="mt-6 flex items-center gap-2 text-[#00FFD1] opacity-0 group-hover:opacity-100 transition-opacity duration-400">
                    <span className="text-sm font-medium">Learn more</span>
                    <ArrowUpRight className="w-4 h-4" />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhatWeDoSection;
